import React, { useEffect, useState } from 'react'
import { Grid, Container } from '@material-ui/core'
import HoldCoCard from './holdCoCard/holdCoCard'
import UserContainer from './holdCoCard/users/userContainer'
import { getData } from './actions'
import VendorContainer from './holdCoCard/vendors/vendorContainer'

export function HoldCoPage() {
  const [cardName, setCardName] = useState(null)
  const [userRecords, setUserRecords] = useState('Loading...')
  const [projectRecords, setProjectRecords] = useState('Loading...')
  const [vendorRecords, setVendorRecords] = useState('Loading...')
  const [departmentRecords, setDepartmentRecords] = useState('Loading...')
  useEffect(() => {
    totalRecords('/userInfo/userList')
    totalRecords('/projects')
    totalRecords('/vendors')
    totalRecords('/departments')
  }, [])

  const totalRecords = async arg => {
    const { data } = await getData(arg)
    if (arg === '/projects') {
      setProjectRecords(data.length)
    } else if (arg === '/vendors') {
      setVendorRecords(data.length)
    } else if (arg === '/departments') {
      setDepartmentRecords(data.length)
    } else {
      setUserRecords(data.length)
    }
  }

  const holdCoCards = [
    {
      name: 'Users',
      description: `${userRecords} Records`
    },
    { name: 'Projects', description: `${projectRecords} Records` },
    { name: 'Vendors', description: `${vendorRecords} Records` },
    { name: 'Departments', description: `${departmentRecords} Records` }
  ]

  const renderData = data => {
    switch (data) {
      case 'Users':
        return <UserContainer handleBack={() => setCardName('')} />

      case 'Vendors':
        return <VendorContainer handleBack={() => setCardName('')} />

      default:
        return (
          <Grid container spacing={2}>
            {holdCoCards.map(card =>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                <HoldCoCard
                  disabled={card.name === 'Users' || card.name === 'Vendors' ? false:true}
                  clicked={() => {
                    setCardName(card.name)
                  }}
                  cardName={card.name}
                  cardDescription={card.description}
                  image='https://images.pexels.com/photos/1837605/pexels-photo-1837605.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500'
                />
              </Grid>
            )}
          </Grid>
        )
    }
  }
  return <Container>{renderData(cardName)}</Container>
}
